import { render, staticRenderFns } from "./transportbhlContract.vue?vue&type=template&id=18e6edd4&"
import script from "./transportbhlContract.vue?vue&type=script&lang=js&"
export * from "./transportbhlContract.vue?vue&type=script&lang=js&"
import style0 from "./transportbhlContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports